import { render, staticRenderFns } from "./cModalBoxes.vue?vue&type=template&id=9fa7b060"
import script from "./cModalBoxes.vue?vue&type=script&lang=js"
export * from "./cModalBoxes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports